module.exports = __webpack_public_path__ + "static/media/facebook-icon.6fa03817.svg";